"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module commutable
 */
/**
 *
 * This is the top level data structure for in memory data structures,
 * and allows converting from on-disk v4 and v3 Jupyter Notebooks
 *
 */
const v4 = __importStar(require("./v4"));
const v3 = __importStar(require("./v3"));
const immutable_1 = require("immutable");
exports.makeNotebookRecord = immutable_1.Record({
    cellOrder: immutable_1.List(),
    cellMap: immutable_1.Map(),
    nbformat_minor: 0,
    nbformat: 4,
    metadata: immutable_1.Map()
});
const freezeReviver = (_k, v) => Object.freeze(v);
/**
 * Converts a string representation of a notebook into a JSON representation.
 *
 * @param notebookString A string representation of a notebook.
 *
 * @returns A JSON representation of the same notebook.
 */
exports.parseNotebook = (notebookString) => JSON.parse(notebookString, freezeReviver);
exports.fromJS = (notebook) => {
    if (immutable_1.Record.isRecord(notebook)) {
        if (notebook.has("cellOrder") && notebook.has("cellMap")) {
            return notebook;
        }
        throw new TypeError(`commutable was passed an Immutable.Record structure that is not a notebook`);
    }
    if (notebook.nbformat === 4 && notebook.nbformat_minor >= 0) {
        var v4Notebook = notebook;
        if (Array.isArray(v4Notebook.cells) &&
            typeof notebook.metadata === "object") {
            return v4.fromJS(v4Notebook);
        }
    }
    else if (notebook.nbformat === 3 && notebook.nbformat_minor >= 0) {
        return v3.fromJS(notebook);
    }
    if (notebook.nbformat) {
        throw new TypeError(`nbformat v${notebook.nbformat}.${notebook.nbformat_minor} not recognized`);
    }
    throw new TypeError("This notebook format is not supported");
};
/**
 * Converts an immutable representation of a notebook to a JSON representation of the
 * notebook using the v4 of the nbformat specification.
 *
 * @param immnb The immutable representation of a notebook.
 *
 * @returns The JSON representation of a notebook.
 */
exports.toJS = (immnb) => {
    const minorVersion = immnb.get("nbformat_minor", null);
    if (immnb.get("nbformat") === 4 &&
        typeof minorVersion === "number" &&
        minorVersion >= 0) {
        return v4.toJS(immnb);
    }
    throw new TypeError("Only notebook formats 3 and 4 are supported!");
};
/**
 * Converts a JSON representation of a notebook into a string representation.
 *
 * @param notebook The JSON representation of a notebook.
 *
 * @returns A string containing the notebook data.
 */
exports.stringifyNotebook = (notebook) => JSON.stringify(notebook, null, 2);
